import { render, staticRenderFns } from "./DispatchesAddedToRouteList.vue?vue&type=template&id=7bc046cb&scoped=true&"
import script from "./DispatchesAddedToRouteList.vue?vue&type=script&lang=js&"
export * from "./DispatchesAddedToRouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc046cb",
  null
  
)

export default component.exports